import { render, staticRenderFns } from "./changeSms.vue?vue&type=template&id=6b7ec21f&scoped=true&"
import script from "./changeSms.vue?vue&type=script&lang=js&"
export * from "./changeSms.vue?vue&type=script&lang=js&"
import style0 from "./changeSms.vue?vue&type=style&index=0&id=6b7ec21f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ec21f",
  null
  
)

component.options.__file = "changeSms.vue"
export default component.exports